module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_8.76ac1053.pdf";